<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div v-for="(item, index) in studyData" :key="index" style='padding-left:20px'>
      <!--    信息表 开始-->
      <div class="mt-6 " style="padding-right:50px;">
        <div class="inline-block text-xl title-line user_info_title" style="margin-top:10px;">
          {{ item.stuName }}培训学员信息登记表
        </div>
        <!-- <p class="mb-6 user_info_title">{{ item.stuName }}培训学员信息登记表</p> -->
        <div style="height:56px"></div>
        <n-table :bordered="true" style="width:1071px;margin-left:40px;text-align: center;" :single-line="false">
          <tbody>
            <tr class="el_table_height">
              <td>姓名</td>
              <td>{{ item.stuName }}</td>
              <td>性别</td>
              <td class="el_table_width">{{ item.sex }}</td>
              <td class="el_table_width">民族</td>
              <td class="el_table_width">{{ item.nationality }}</td>
              <td rowspan="3" class="el_table_img">
                <el-image v-if="item.photo !== ''" style="width: 200px; height: 200px; line-height: 200px"
                  align="center" :fit="fit" :src="item.photo" :preview-src-list="[item.photo]">
                </el-image>
                <div style="text-align: center; font-size: 30px; color: #efeff5" v-else>未上传</div>
              </td>
              <!--            <td>干！我刚才背的是啥</td>-->
            </tr>
            <tr class="el_table_height">
              <td>身份证号</td>
              <td colspan="5">{{ item.idNumber }}</td>
              <!--            <td>彻底废除</td>-->
              <!--            <td>...</td>-->
              <!--            <td>干！我刚才背的是啥</td>-->
              <!--            <td>彻底废除</td>-->
              <!--            <td>...</td>-->
              <!--            <td>干！我刚才背的是啥</td>-->
            </tr>
            <tr class="el_table_height">
              <td>户籍所在地</td>
              <td colspan="2">{{ item.domicileAddress }}</td>
              <!--            <td>彻底废除</td>-->
              <td>户籍性质</td>
              <td colspan="2">{{ item.accountNature }}</td>
              <!--            <td></td>-->
              <!--            <td>...</td>-->
              <!--            <td>干！我刚才背的是啥</td>-->
            </tr>
            <tr class="el_table_height">
              <td>毕业院校</td>
              <td colspan="2">{{ item.graduatedSchool }}</td>
              <!--            <td>彻底废除</td>-->
              <td>所学专业</td>
              <td colspan="4">{{ item.stuMoreInfo.profession }}</td>
              <!--            <td>彻底废除</td>-->
              <!--            <td>...</td>-->
              <!--            <td>干！我刚才背的是啥</td>-->
            </tr>
            <tr class="el_table_height">
              <td>学历</td>
              <td colspan="2">{{ item.education }}</td>
              <!--            <td>彻底废除</td>-->
              <td>培训类型</td>
              <td colspan="4">{{ item.trainType }}</td>
              <!--            <td>彻底废除</td>-->
              <!--            <td>...</td>-->
              <!--            <td>干！我刚才背的是啥</td>-->
            </tr>
            <tr class="el_table_height">
              <td>人员类别</td>
              <td colspan="2">{{ item.stuTypeName }}</td>
              <!--            <td>彻底废除</td>-->
              <td>联系电话</td>
              <td colspan="4">{{ item.mobilePhone }}</td>
              <!--            <td>彻底废除</td>-->
              <!--            <td>...</td>-->
              <!--            <td>干！我刚才背的是啥</td>-->
            </tr>
            <tr class="el_table_height">
              <td rowspan="2">学习情况</td>
              <td>线上学时</td>
              <td colspan="2">{{ item.onPeriodSum }}</td>
              <!--            <td>...</td>-->
              <td colspan="2">线上成绩</td>
              <!--            <td>彻底废除</td>-->
              <td colspan="2">{{ item.examScore }}</td>
              <!--            <td>干！我刚才背的是啥</td>-->
            </tr>
            <tr class="el_table_height">
              <!--            <td>放弃</td>-->
              <td>线下学时</td>
              <td colspan="2">{{ item.curriculumList[0].sum }}</td>
              <!--            <td>...</td>-->
              <td colspan="2">直播学时</td>
              <!--            <td>彻底废除</td>-->
              <td colspan="2">{{ item.liveCredit }}</td>
              <!--            <td>干！我刚才背的是啥</td>-->
            </tr>
          </tbody>
        </n-table>
      </div>
      <!--    信息表 结束-->
      <div class="inline-block text-xl title-line user_info_title" style="margin-top:50px;">
        学习材料领取登记表
      </div>
      <!-- <div class="user_info_title mt-10 mb-10 w1130">学习材料领取登记表</div> -->
      <div class="w1130 " style="margin-top:56px;">
        <n-table style="width:1071px;margin-left:40px;text-align: center;" :bordered="true" :single-line="false">
          <tbody>
            <tr>
              <td>书包</td>
              <td>笔</td>
              <td>笔记本</td>
              <td>教材</td>
              <td>领取人签名</td>
              <td>备注</td>
            </tr>
            <tr>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>1</td>
              <td>
                <el-image v-if="item.signature !== ''" style="width: 60px; height: 60px; line-height: 60px"
                  align="center" :src="item.signature" :preview-src-list="[item.signature]">
                </el-image>
                <div v-else style="color: #c0c4cc">未签字</div>
              </td>
              <td></td>
            </tr>
          </tbody>
        </n-table>
      </div>
      <div class="inline-block text-xl title-line user_info_title" style="margin-top:50px;">
        相关证明材料
      </div>
      <!--    复印件-->
      <div class="mt-10  flex " style='justify-content: space-between;margin-top:56px;margin-right:50px'>
        <div>
          <p class="user_info_title mb-10">身份证正面</p>
          <div class="f_s_img">
            <el-image v-if="item.identityUpPhoto !== ''" style="height: 146px; width: 254px" align="center"
              :src="item.identityUpPhoto" :preview-src-list="[item.identityUpPhoto]">
            </el-image>
            <div v-else class="w_s_c_x">未上传</div>
          </div>
        </div>
        <div>
          <p class="user_info_title mb-10 ">身份证反面</p>
          <div class="f_s_img">
            <el-image v-if="item.identityDownPhoto !== ''" style="height: 146px; width: 254px" align="center"
              :src="item.identityDownPhoto" :preview-src-list="[item.identityDownPhoto]">
            </el-image>
            <div v-else class="w_s_c_x">未上传</div>
          </div>
        </div>
        <div>
          <p class="user_info_title mb-10">相关证明1</p>
          <div class="f_s_img">
            <el-image v-if="item.proof !== ''" style="height: 146px; width: 254px" align="center" :src="item.proof"
              :preview-src-list="[item.proof]">
            </el-image>
            <div v-else class="w_s_c_x">未上传</div>
          </div>
        </div>
        <div>
          <p class="user_info_title mb-10">相关证明2</p>
          <div class="f_s_img">
            <el-image v-if="item.qualification !== ''" style="height: 146px; width: 254px" align="center"
              :src="item.qualification" :preview-src-list="[item.qualification]">
            </el-image>
            <div v-else class="w_s_c_x">未上传</div>
          </div>
        </div>
      </div>
      <div class="inline-block text-xl title-line user_info_title" style="margin-top:50px;">
        {{ item.stuName }}线下课程明细
      </div>
      <!--    线下课学时-->
      <div class="w1130" style="margin-top:56px">
        <!-- <p class="user_info_title">{{ item.stuName }}线下课程明细</p> -->
        <p style="text-align: right;width:1071px;margin-left:40px;" tyle="width:1071px;margin-left:40px;">线下已完成共计 :
          {{ item.curriculumList[0].sum }} 学时
        </p>
        <el-table border :data="item.curriculumList" style="width:1071px;margin-left:40px;"
          :span-method="arraySpanMethodGx">
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column label="日期" prop="classTime"> </el-table-column>
          <el-table-column label="时间" prop="startTime" width="200"> </el-table-column>
          <el-table-column label="课程名称" prop="courseName"> </el-table-column>
          <el-table-column label="地点" prop="addressName"> </el-table-column>
          <el-table-column label="课时" prop="hour"> </el-table-column>
          <el-table-column label="签到信息">
            <template v-slot="scope">
              <el-image v-if="scope.row.sign !== '未签到'" style="width: 40px; height: 30px; line-height: 30px"
                fit="contain" align="center" :src="scope.row.sign" :preview-src-list="[scope.row.sign]">
              </el-image>
              <el-image v-if="scope.row.signature !== ''" style="width: 40px; height: 30px; line-height: 30px"
                align="center" :src="scope.row.signature" :preview-src-list="[scope.row.signature]" alt="111">
              </el-image>
              <span v-if="scope.row.sign === '' ? (scope.row.signature === '' ? true : false) : false">---</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="inline-block text-xl title-line user_info_title" style="margin-top:50px;">
        {{ item.stuName }}线上课程明细
      </div>
      <!--    线下课学时-->
      <div class="w1130" style="margin-top:50px;">
        <!-- <p class="user_info_title mt-10">{{ item.stuName }}线上课程明细</p> -->
        <p style="text-align: right;width:1071px;margin-left:40px;">线上已完成共计 : {{ item.onPeriodSum }} 学时</p>
        <el-table border :data="item.classDetailsList" style="width:1071px;margin-left:40px;"
          :span-method="arraySpanMethodGs">
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column label="课程名称" prop="courseName"> </el-table-column>
          <el-table-column label="章节名称" prop="chapterName" width="200"> </el-table-column>
          <el-table-column label="课程内容" prop="videoName"> </el-table-column>
          <el-table-column label="学时" prop="period"> </el-table-column>
          <el-table-column label="获得学习时间" prop="signTime"> </el-table-column>
        </el-table>
      </div>

      <div class="inline-block text-xl title-line user_info_title" style="margin-top:50px;">
        {{ item.stuName }}直播观看明细
      </div>
      <!--      直播观看 明细-->
      <div class="w1130" style="margin-top:56px">
        <!-- <p class="user_info_title mt-10 mb-10">{{ item.stuName }}直播观看明细</p> -->
        <el-table border style="text-align: right;width:1071px;margin-left:40px;" :data="item.liveDetails">
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column label="日期" width="120" prop="liveDay"> </el-table-column>
          <el-table-column label="课程名称" prop="liveTitle" width="250"> </el-table-column>
          <el-table-column label="授课老师" width="80" prop="lecturersName"> </el-table-column>
          <el-table-column label="课程内容" prop="liveContent"> </el-table-column>
          <el-table-column label="开始时间" width="90" prop="liveStartTime"> </el-table-column>
          <el-table-column label="结束时间" width="90" prop="liveEndTime"> </el-table-column>
          <el-table-column label="课时" width="80" prop="liveHour"> </el-table-column>
          <el-table-column label="获得学分" width="80" prop="watchTime"> </el-table-column>
        </el-table>
      </div>
      <div class="" style="height:60px;">

      </div>
    </div>
    <div class="footere">
      <div class="gotop top_hui" v-show="gotop" @click="toTop">Top 回到顶部</div>
    </div>
  </div>
</template>

<script>
import { getUserInfoApi, grdetailList } from '@/api';
import {
  dictionariesSex,
  dictionariesNationality,
  dictionariesAccountYype,
  dictionariesEducation,
} from '@/api/dictionaries';
export default {
  data () {
    return {
      gotop: false,
      fullscreenLoading: true,
      imgBaseUrl: 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/',
      fit: 'contain',
      studyData: [],
    };
  },
  methods: {
    getTableDataGs () {
      let spanOneArr = [];
      let spanTwoArr = [];
      let concatOne = 0;
      let concatTwo = 0;
      this.studyData[0].classDetailsList.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1);
          spanTwoArr.push(1);
        } else {
          if (item.courseName === this.studyData[0].classDetailsList[index - 1].courseName) {
            spanOneArr[concatOne] += 1;
            spanOneArr.push(0);
          } else {
            spanOneArr.push(1);
            concatOne = index;
          }
        }
      });
      return {
        one: spanOneArr,
        two: spanTwoArr,
      };
    },
    // 个人学习报告 线上表格合并
    arraySpanMethodGs ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row = this.getTableDataGs(this.JZPFDataGxs).one[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },

    getTableDataGx () {
      let spanOneArr = [];
      let spanTwoArr = [];
      let concatOne = 0;
      let concatTwo = 0;
      this.studyData[0].curriculumList.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1);
          spanTwoArr.push(1);
        } else {
          if (item.classTime === this.studyData[0].curriculumList[index - 1].classTime) {
            spanOneArr[concatOne] += 1;
            spanOneArr.push(0);
          } else {
            spanOneArr.push(1);
            concatOne = index;
          }
        }
      });
      return {
        one: spanOneArr,
        two: spanTwoArr,
      };
    },
    // 个人学习报告线下 表格时间合并
    arraySpanMethodGx ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row = this.getTableDataGx(this.JZPFDataGx).one[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },

    // 回到顶部
    handleScroll () {
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop () {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },
  mounted () {
    console.log('加载完毕');
    // 获取个人信息
    getUserInfoApi().then(res => {
      if (res.success === true) {
        grdetailList({ ids: res.data.id }).then(res => {
          this.fullscreenLoading = false;
          this.studyData = res.data;

          //
          for (let i = 0; i < this.studyData.length; i++) {
            // 字典 转换
            // 性别
            dictionariesSex().then(res => {
              for (let b = 0; b < res.data.length; b++) {
                if (this.studyData[i].sex === res.data[b].dictKey) {
                  this.studyData[i].sex = res.data[b].dictValue;
                }
              }
            });
            // 民族
            dictionariesNationality().then(res => {
              for (let m = 0; m < res.data.length; m++) {
                if (this.studyData[i].nationality === res.data[m].dictKey) {
                  this.studyData[i].nationality = res.data[m].dictValue;
                }
              }
            });
            // 户籍性质
            dictionariesAccountYype().then(res => {
              for (let h = 0; h < res.data.length; h++) {
                if (this.studyData[i].accountNature === res.data[h].dictKey) {
                  this.studyData[i].accountNature = res.data[h].dictValue;
                }
              }
            });
            // 学历
            dictionariesEducation().then(res => {
              for (let l = 0; l < res.data.length; l++) {
                if (this.studyData[i].education === res.data[l].dictKey) {
                  this.studyData[i].education = res.data[l].dictValue;
                }
              }
            });

            // 头像
            if (this.studyData[i].photo !== '') {
              this.studyData[i].photo = this.imgBaseUrl + this.studyData[i].photo;
            }
            // 领取人 签字 signature
            if (this.studyData[i].signature !== '') {
              this.studyData[i].signature = this.imgBaseUrl + this.studyData[i].signature;
            }
            // 身份证 正面
            if (this.studyData[i].identityUpPhoto !== '') {
              this.studyData[i].identityUpPhoto =
                this.imgBaseUrl + this.studyData[i].identityUpPhoto;
            }
            // 身份证 反面
            if (this.studyData[i].identityDownPhoto !== '') {
              this.studyData[i].identityDownPhoto =
                this.imgBaseUrl + this.studyData[i].identityDownPhoto;
            }
            // 相关证明 1
            if (this.studyData[i].proof !== '') {
              this.studyData[i].proof = this.imgBaseUrl + this.studyData[i].proof;
            }
            // 相关证明 2
            if (this.studyData[i].qualification !== '') {
              this.studyData[i].qualification = this.imgBaseUrl + this.studyData[i].qualification;
            }

            for (let x = 0; x < this.studyData[i].curriculumList.length; x++) {
              // 线下 签到图片平拼接
              if (this.studyData[i].curriculumList[x].sign !== '未签到') {
                this.studyData[i].curriculumList[x].sign =
                  this.imgBaseUrl + this.studyData[i].curriculumList[x].sign;
              }
              // 线下 签到图片平拼接
              if (this.studyData[i].curriculumList[x].signature !== '') {
                this.studyData[i].curriculumList[x].signature =
                  this.imgBaseUrl + this.studyData[i].curriculumList[x].signature;
              }
              //  判断 上午 下午 晚上
              let xianxia = this.studyData[i].curriculumList;
              xianxia[x].kai = new Date(xianxia[x].classTime + ' ' + xianxia[x].startTime);
              xianxia[x].jie = new Date(xianxia[x].classTime + ' ' + xianxia[x].endTime);
              if (xianxia[x].kai.getHours() >= 6 && xianxia[x].jie.getHours() <= 12) {
                // console.log("我是上午")
                xianxia[x].startTime = '(上午)' + xianxia[x].startTime + '-' + xianxia[x].endTime;
              } else if (xianxia[x].kai.getHours() >= 12 && xianxia[x].jie.getHours() < 18) {
                // console.log("我是下午")
                xianxia[x].startTime = '(下午)' + xianxia[x].startTime + '-' + xianxia[x].endTime;
              } else if (xianxia[x].kai.getHours() >= 18 && xianxia[x].jie.getHours() <= 24) {
                // console.log("我是晚上")
                xianxia[x].startTime = '(晚上)' + xianxia[x].startTime + '-' + xianxia[x].endTime;
              }
            }
          }
          console.log(this.studyData);
        });
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
        });
      }
    });

    // 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener('scroll', this.handleScroll, true);
  },
};
</script>

<style lang="scss" scoped>
.border-bottoms {
  border-bottom: 1px solid rgba(209, 213, 219);
}
.title-line {
  position: relative;
  text-align: left;
  padding-bottom: 10px;
  &:after {
    position: absolute;
    content: '';
    height: 6px;
    width: 44px;
    background-color: #2d60f6;
    left: 0;
    bottom: -5px;
    transform: translateX(0);
  }
}
.box_my {
  border: 1px solid #d1d5db;
}
.my_title {
  font-size: 26px;
  font-weight: 600;
  text-align: center;
}
.el_table_width {
  width: 150px;
}
.el_table_img {
  border: 1px solid #efeff5;
  width: 150px;
}
.el_table_height {
  height: 70px;
}
.f_s_img {
  width: 254px;
  height: 146px;
  margin: 0 auto;
  border: 1px solid #efeff5;
}
.w_s_c_x {
  text-align: center;
  line-height: 333px;
  font-size: 70px;
  color: #efeff5;
}

.footere .gotop {
  text-align: center;
  position: fixed;
  right: 50px;
  bottom: 30px;
  cursor: pointer;
  padding: 10px;
  color: #000000;
}
.top_hui {
  background-color: #f2f5f6;
  box-shadow: 0px 9px 19px -3px #999;
}
.top_hui:hover {
  background-color: #ff5725;
  box-shadow: 0px 9px 19px -3px #fe7e35;
}
.user_info_title {
  font-size: 22px;
  font-weight: normal;
  color: #111;
  text-align: center;
}
.w1130 {
  width: 1130px;
}
</style>
